<template>
  <seo-lang code="ES" url="https://consejodsabios.netlify.app/" current></seo-lang>
  <title>Consejo de sabios -Podcast-</title>
  
  <div id="app" @mousemove="handleMouseMove">

      <header_app></header_app>

      <background-app></background-app>
  </div>
  <footer_app></footer_app>


</template>

<script>

const position = document.documentElement;


window.addEventListener("load", function() {
    position.style.setProperty("--x", window.innerWidth / 2 + "px");
});

position.addEventListener("mousemove", (e) => {
  position.style.setProperty("--x", e.clientX + "px");
});

import BackgroundApp from './components/background_app.vue';
import HeaderApp from './components/header_app.vue';
import FooterApp from './components/footer_app.vue';

export default {
  components: {
    'background-app': BackgroundApp,
    'header_app': HeaderApp,
    'footer_app': FooterApp,
  },
}


</script>


<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap');
#app {
  overflow: hidden;
  background-color: #000;
  height: 650vh;
  width: 100%;
  position: relative;
}

* {
  margin: 0;
  padding: 0;
  font-family: "roboto";
  font-weight: 900;
  
}

.nosotros{
  position: relative; /* Posición fija */
  margin-left: 28%;
  margin-right: 28%;
  top: 45vh;
  left: 5vh;
  right: 5vh;
  bottom: 0;
  height: 10vh;
  text-align: center;
  background-color: rgb(0, 0, 0);
  z-index: 2; /* Asegura que esté por encima del contenido */
  box-shadow: 6px 20px 10px rgba(0, 0, 0, 0.699);
}

.nosotros h2{
  font-family: "roboto";
  
  width: 100%; /* Ajustar el 100% del ancho del contenedor del texto */
  height: 100%; /* Ajustar la altura al 100% del contenedor del texto */
  overflow: hidden; /* Ocultar cualquier contenido que se desborde */
  display: flex; /* Utilizar flexbox para centrar vertical y horizontalmente el texto */
  align-items: center;
  justify-content: center;
  color: white; /* Color del texto */
  font-size: 3em;
}



.overlay {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  height: 50vh;
  top: 10%;
  left: 5%;
  right: 5%;
  bottom: 5%;
  text-align: center;
  background-color: rgb(0, 0, 0);
  box-shadow: 0 0 10px 1px #fffb00;
  border-radius: 10px;
  z-index: 1; /* Asegura que esté por encima del contenido */
}

.overlay h1{
  color: #ffd92d;
  text-align: center;
  font-size: 4em;
}


.overlay h2{
  color: #ffd92d;
  text-align: center;
  font-size: 4em;
}

a {
  text-decoration: none;
}

section {
  position: relative;

  overflow: hidden;
  background: #000000;
}


</style>
